import { render, staticRenderFns } from "./OperaBettingConfigWindow.vue?vue&type=template&id=d178ec98&"
import script from "./OperaBettingConfigWindow.vue?vue&type=script&lang=js&"
export * from "./OperaBettingConfigWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports